import React, { memo } from 'react';

import Container from 'react-bootstrap/Container';
import Lottie from 'react-lottie-player';

import PoweredBy from '../Component/General/PoweredBy';
import { useSelector } from 'react-redux';
import { RootState } from '../Store';
import { AppState } from '../Store/App/state';

import systemMessageAnimation from '../Data/Lottie/systemMessageAnimation.json';
import { Markdown } from '../Component/General/Markdown';

const SystemMessagePage: React.FC = () => {
    const { lastResponseMessage } = useSelector<RootState, AppState>(state => state.app);

    return (
        <>
            <Container className="loading-container">
                <div>
                    <Lottie
                        loop
                        animationData={systemMessageAnimation}
                        play
                        style={{ width: 350, height: 300, margin: '0 auto' }}
                    />
                    <Markdown text={lastResponseMessage || ''} />
                </div>
            </Container>
            <PoweredBy />
        </>
    );
};

export default memo(SystemMessagePage);
